import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";
import { apiCaller } from "../functions";

export function useUserApi() {
    const callApi = useApiCall();

    return {
        login: apiCaller(callApi, SAGA_ACTIONS.USER.LOGIN),
        logout: apiCaller(callApi, SAGA_ACTIONS.USER.LOGOUT),

        register: apiCaller(callApi, SAGA_ACTIONS.USER.REGISTER),
        forgotPassword: apiCaller(callApi, SAGA_ACTIONS.USER.FORGET_PASSWORD),
        resetPassword: apiCaller(callApi, SAGA_ACTIONS.USER.RESET_PASSWORD),
        getDesigns: apiCaller(callApi, SAGA_ACTIONS.USER.GET_DESIGNS),
        saveDesign: apiCaller(callApi, SAGA_ACTIONS.USER.SAVE_DESIGN),
        updateDesign: apiCaller(callApi, SAGA_ACTIONS.USER.UPDATE_DESIGN),
        getImages: apiCaller(callApi, SAGA_ACTIONS.USER.IMAGE_LIST),
        uploadImage: apiCaller(callApi, SAGA_ACTIONS.USER.IMAGE_UPLOAD),
        deleteImage: apiCaller(callApi, SAGA_ACTIONS.USER.IMAGE_DELETE),

        getMenus: apiCaller(callApi, SAGA_ACTIONS.USER.GET_MENUS),
        getUserActivity: apiCaller(callApi, SAGA_ACTIONS.USER.GET_USER_ACTIVITY),
        getLastPunchStatus: apiCaller(callApi, SAGA_ACTIONS.USER.LAST_PUNCH_STATUS),
        clockIn: apiCaller(callApi, SAGA_ACTIONS.USER.CLOCK_IN),
    };
}
